import React, {useEffect, useState} from 'react';
import {Grid} from "@mui/material";
import {SETable} from "../../../../components/SETable";
import {RiCheckboxCircleFill, RiErrorWarningFill, RiFilterOffLine} from "react-icons/ri";
import {SEText} from "../../../../components/SEText";
import useFilterHandler from "../../../../hooks/useFilterHandler";
import {useQuery} from "react-query";
import {tableColumns} from "./tableColumns";
import {SolicitacaoDeVinculoService} from "../services";
import {SolicitacaoDeVinculoInterface} from "../../../../interfaces";
import {SEButton} from "../../../../components/SEButton";
import useAbortableRequest from "../../../../../hooks/useAbortableRequest";
import SEInputSearch from "../../../../components/SEInputSearch";
import {removeEmptyProperties} from "../../../../utils/utils";
import useExcelExport from "../../../../hooks/useExcelExport";
import {formatDateToBR} from "../../../../../utils/time";
import {SEButtonExport} from "../../../../components/SEButtonExport";
import {handleModalAdmin} from "../../../../../utils/handleModalAdmin";
import {BaSeDialogContext} from "@base/react";
import moment from "moment";
import {cnpjMask, cpfMask} from "../../../../../utils/mask";

const Tabela = () => {

    const { showModal } = React.useContext(BaSeDialogContext);

    const [searchText, setSearchText] = useState<any>(null);

    const {createAbortController, cancelRequests} = useAbortableRequest();

    const {
        paginationFilters,
        bodyFilters,
        handleResetBodyFilters,
        handleChangeBodyFilter,
        setPaginationFilters,
        handleLinesPerPage,
        handleChangeOrder,
        handlePageChange,
        handleSearchChange,
    } = useFilterHandler();

    const handleClickApplyFilter = async (inputValue: any, oqueVocePrecisa: boolean = false) => {
        setSearchText(inputValue);
        handleSearchChange(inputValue, oqueVocePrecisa)
    }

    const handleCleanFilters = () => {
        handleResetBodyFilters()
        setSearchText(null)
    }

    const {
        data, isLoading, refetch
    } = useQuery({
        queryFn: () => SolicitacaoDeVinculoService.findAll(paginationFilters, bodyFilters, createAbortController()),
        queryKey: ["solicitacaoDeVinculo", paginationFilters, bodyFilters],
    });

    const fetchDataExcel = async () => {
        const bodyParams = removeEmptyProperties(bodyFilters);
        const pageFilter = {...paginationFilters, page: 0, linesPerPage: 1000};
        const response = await SolicitacaoDeVinculoService.findAll(pageFilter, bodyParams);
        return response?.content?.map((data: any) => ({
            DATA: moment(data?.dataCriacao).format("DD/MM/YYYY"),
            CPF: cpfMask(data?.administrador?.cpf),
            CNPJ: cnpjMask(data?.empreendedor?.cnpj)
        }));
    };

    const {executeDownload, downloading} = useExcelExport({
        handleDataCallback: fetchDataExcel,
        filename: `Exportacao_Solicitacao_De_Vinculo_${formatDateToBR(new Date())}`,
        colorLoading: '#3498db',
        isCsv: true,
    });

    const vincular = async (item: SolicitacaoDeVinculoInterface) => {
        console.log('changeVinculoEmpresaAssociar', item)
        const associar = SolicitacaoDeVinculoService.associar(
            item.administrador.cpf,
            item.empreendedor.cnpj,
            item.relacao
        );
        return await associar;
    };

    const desvincular = async (item: SolicitacaoDeVinculoInterface) => {
        console.log('changeVinculoEmpresaDessassociar', item)
        const desassociar = SolicitacaoDeVinculoService.desassociar(
            item.administrador.cpf,
            item.empreendedor.cnpj
        );
        return await desassociar;
    };

    const handleUpdateStatus = async (item: SolicitacaoDeVinculoInterface) => {
        handleModalAdmin({
            title: `${!item.pendente ? 'Vincular' : 'Desvincular'} empresa`,
            content: `Você pode alterar o vínculo da empresa. Escolha uma das opções abaixo`,
            msgOnSuccess: `O status do vinculo foi ${
                !item.pendente ? 'Desaprovado' : 'Aprovado'
            } com sucesso`,
            msgOnError: `O status do vinculo não foi ${
                !item.pendente ? 'Desaprovado' : 'Aprovado'
            } Aconteceu um erro ou o sistema está temporariamente fora do ar. Tente novamente mais tarde.`,
            onFinish: () => refetch(),
            onConfirmClick: () => item.pendente ? vincular(item) : desvincular(item),
            onCancelClick: () => console.log('modal closed...'),
            showModal: showModal,
        });
    };

    const handleFilterByStatus = (status: boolean) => {
        handleChangeBodyFilter("pendente", status);
        setPaginationFilters({
            ...paginationFilters,
            page: 0,
        });
    };


    useEffect(() => {
        return () => {
            cancelRequests();
        }
        // eslint-disable-next-line
    }, []);

    return (
        <Grid item>
            <Grid container>
                <Grid item xs={12}>
                    <SETable
                        pagination={true}
                        headerTableColor={"#7B80FF"}
                        tableColor={"#FFFFFF"}
                        totalElements={data?.totalElements}
                        totalPages={data?.totalPages}
                        linesPerPageFilters={paginationFilters?.linesPerPage}
                        isLoading={isLoading}
                        data={data?.content ?? []}
                        page={paginationFilters?.page}
                        columns={tableColumns({handleUpdateStatus})}
                        orderBy={paginationFilters?.orderBy}
                        direction={paginationFilters?.direction}
                        onOrderChange={handleChangeOrder}
                        onPagePreviousChange={handlePageChange}
                        onPageNextChange={handlePageChange}
                        onLinesPerPageChange={handleLinesPerPage}
                        tableHeader={
                            <>
                                <Grid container justifyContent="space-between" alignItems="center" spacing={2} mb={2}>


                                    <Grid item md={3}>
                                        <SEInputSearch
                                            value={searchText}
                                            onClick={(inputValue) => handleClickApplyFilter(inputValue, false)}
                                        />
                                    </Grid>

                                    <Grid item md={3}>
                                        <Grid container spacing={1} alignItems="center">
                                            <Grid item>
                                                <SEButton
                                                    selected={bodyFilters.pendente === false}
                                                    onClick={() => handleFilterByStatus(false)}
                                                >
                                                    <RiCheckboxCircleFill size={26} color="#66BD91" />{" "}
                                                    Vínculo Aprovado
                                                </SEButton>
                                            </Grid>
                                            <Grid item>
                                                <SEButton
                                                    selected={bodyFilters.pendente === true}
                                                    onClick={() =>
                                                        handleFilterByStatus(true)
                                                    }
                                                >
                                                    <RiErrorWarningFill size={26} color="#F6E566" title={"Pendente"}/> Vínculo Pendente
                                                </SEButton>
                                            </Grid>
                                        </Grid>
                                    </Grid>

                                    <Grid item>
                                        <SEButtonExport isLoading={downloading} onClick={executeDownload}/>
                                    </Grid>

                                </Grid>

                                <Grid container justifyContent="space-between" alignItems="center" mb={2}
                                      sx={{padding: '7px'}}>
                                    <Grid item>
                                        <div
                                            style={{
                                                display: "flex",
                                                marginTop: "16px",
                                                alignItems: "center",
                                            }}
                                        >
                                            {!!data?.totalElements && (
                                                <SEText as="p" font="Mulish">
                                                    <strong>{data?.totalElements}</strong>{" "}
                                                    {data?.totalElements === 1
                                                        ? "resultado encontrado"
                                                        : "resultados encontrados"}
                                                </SEText>
                                            )}
                                        </div>
                                    </Grid>

                                    <Grid item>
                                        <div
                                            style={{
                                                display: "flex",
                                                marginTop: "16px",
                                                alignItems: "center",
                                            }}
                                        >
                                            <SEButton onClick={handleCleanFilters}>
                                                <RiFilterOffLine size={20}/> Limpar Filtros
                                            </SEButton>
                                        </div>
                                    </Grid>


                                </Grid>
                            </>
                        }
                    />
                </Grid>
            </Grid>
        </Grid>
    );
};

export default Tabela;